// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"67f68ebd","271":"77789584","892":"3347fb0c"}[chunkId] + ".chunk.js";
};